export const FEATURES = Object.freeze({
  VIDEO: 'VIDEO',
  INTEGRATIONS: 'INTEGRATIONS',
  VIDEO_OPTIONS_VISIBLE: 'VIDEO_OPTIONS_VISIBLE',
  PROJECT_COLLABORATION: 'PROJECT_COLLABORATION',
  REPORT_GENERATION: 'REPORT_GENERATION',
  BEFORE_AFTER_PHOTOS: 'BEFORE_AFTER_PHOTOS',
  GALLERY_LINKS: 'GALLERY_LINKS',
  REPORT_TEXT_SNIPPETS: 'REPORT_TEXT_SNIPPETS',
  TASK_LISTS: 'TASK_LISTS',
  LOGO_STICKERS: 'LOGO_STICKERS',
  REPORT_TEMPLATES: 'REPORT_TEMPLATES',
  TEMPLATES: 'TEMPLATES',
  DOCUMENT_SIGNING: 'DOCUMENT_SIGNING',
  TRUSTY: 'TRUSTY',
  PAYMENTS: 'PAYMENTS',
  COMPANY_DASHBOARD: 'COMPANY_DASHBOARD',
  CHECKLIST_ASSIGNMENT: 'CHECKLIST_ASSIGNMENT',
  ULTRA_RES_IMAGES: 'ULTRA_RES_IMAGES',
  VIDEO_WALKTHROUGHS: 'VIDEO_WALKTHROUGHS',
});

type FeatureKey = keyof typeof FEATURES;

type FeatureSet = {
  video: boolean;
  integrations: boolean;
  videoOptionsVisible: boolean;
  projectCollaboration: boolean;
  reportGeneration: boolean;
  beforeAfterPhotos: boolean;
  galleryLinks: boolean;
  reportTextSnippets: boolean;
  taskLists: boolean;
  logoStickers: boolean;
  reportTemplates: boolean;
  templates: boolean;
  documentSigning: boolean;
  trusty: boolean;
  payments: boolean;
  companyDashboard: boolean;
  checklistAssignment: boolean;
  ultraResImages: boolean;
  videoWalkthroughs: boolean;
};

const keyMap: { [key in FeatureKey]: keyof FeatureSet } = Object.freeze({
  [FEATURES.VIDEO]: 'video',
  [FEATURES.INTEGRATIONS]: 'integrations',
  [FEATURES.VIDEO_OPTIONS_VISIBLE]: 'videoOptionsVisible',
  [FEATURES.PROJECT_COLLABORATION]: 'projectCollaboration',
  [FEATURES.REPORT_GENERATION]: 'reportGeneration',
  [FEATURES.BEFORE_AFTER_PHOTOS]: 'beforeAfterPhotos',
  [FEATURES.GALLERY_LINKS]: 'galleryLinks',
  [FEATURES.REPORT_TEXT_SNIPPETS]: 'reportTextSnippets',
  [FEATURES.TASK_LISTS]: 'taskLists',
  [FEATURES.LOGO_STICKERS]: 'logoStickers',
  [FEATURES.REPORT_TEMPLATES]: 'reportTemplates',
  [FEATURES.TEMPLATES]: 'templates',
  [FEATURES.DOCUMENT_SIGNING]: 'documentSigning',
  [FEATURES.TRUSTY]: 'trusty',
  [FEATURES.PAYMENTS]: 'payments',
  [FEATURES.COMPANY_DASHBOARD]: 'companyDashboard',
  [FEATURES.CHECKLIST_ASSIGNMENT]: 'checklistAssignment',
  [FEATURES.ULTRA_RES_IMAGES]: 'ultraResImages',
  [FEATURES.VIDEO_WALKTHROUGHS]: 'videoWalkthroughs',
});

export const canAccessFeature = (
  featureSet: FeatureSet,
  featureId: FeatureKey,
) => {
  if (!featureSet) {
    return false;
  }

  return !!featureSet[keyMap[featureId]];
};
